export default "__VITE_ASSET__D$iVXYX3__"